var map = {
	"./banner-77-travel-m.webp": 73626,
	"./banner-77-travel.webp": 57475,
	"./central/ang-thong/ang-thong-1.webp": 45827,
	"./central/ang-thong/ang-thong-2.webp": 84906,
	"./central/ang-thong/ang-thong-3.webp": 38898,
	"./central/ang-thong/ang-thong-4.webp": 941,
	"./central/ang-thong/ang-thong-5.webp": 90923,
	"./central/ang-thong/ang-thong-6.webp": 64240,
	"./central/ang-thong/ang-thong-thumb.webp": 99325,
	"./central/ayutthaya/ayutthaya-1.webp": 39339,
	"./central/ayutthaya/ayutthaya-2.webp": 88084,
	"./central/ayutthaya/ayutthaya-3.webp": 61565,
	"./central/ayutthaya/ayutthaya-4.webp": 6761,
	"./central/ayutthaya/ayutthaya-5.webp": 95625,
	"./central/ayutthaya/ayutthaya-6.webp": 24539,
	"./central/ayutthaya/ayutthaya-thumb.webp": 77737,
	"./central/bangkok/bangkok-1.webp": 45729,
	"./central/bangkok/bangkok-2.webp": 81261,
	"./central/bangkok/bangkok-3.webp": 72771,
	"./central/bangkok/bangkok-4.webp": 3383,
	"./central/bangkok/bangkok-5.webp": 68541,
	"./central/bangkok/bangkok-6.webp": 47981,
	"./central/bangkok/bangkok-thumb.webp": 98271,
	"./central/chainat/chainat-1.webp": 31961,
	"./central/chainat/chainat-2.webp": 58684,
	"./central/chainat/chainat-3.webp": 13813,
	"./central/chainat/chainat-4.webp": 27699,
	"./central/chainat/chainat-5.webp": 64257,
	"./central/chainat/chainat-6.webp": 58957,
	"./central/chainat/chainat-thumb.webp": 99717,
	"./central/kanchanaburi/kanchanaburi-1.webp": 35565,
	"./central/kanchanaburi/kanchanaburi-2.webp": 45660,
	"./central/kanchanaburi/kanchanaburi-3.webp": 46778,
	"./central/kanchanaburi/kanchanaburi-4.webp": 80008,
	"./central/kanchanaburi/kanchanaburi-5.webp": 13592,
	"./central/kanchanaburi/kanchanaburi-thumb.webp": 71713,
	"./central/lopburi/lopburi-1.webp": 49689,
	"./central/lopburi/lopburi-2.webp": 33268,
	"./central/lopburi/lopburi-3.webp": 23159,
	"./central/lopburi/lopburi-4.webp": 30644,
	"./central/lopburi/lopburi-5.webp": 61084,
	"./central/lopburi/lopburi-6.webp": 97921,
	"./central/lopburi/lopburi-thumb.webp": 81109,
	"./central/nakhon-pathom/nakhon-pathom-01.webp": 81271,
	"./central/nakhon-pathom/nakhon-pathom-02.webp": 71215,
	"./central/nakhon-pathom/nakhon-pathom-03.webp": 17432,
	"./central/nakhon-pathom/nakhon-pathom-04.webp": 70087,
	"./central/nakhon-pathom/nakhon-pathom-05.webp": 55352,
	"./central/nakhon-pathom/nakhon-pathom-06.webp": 88251,
	"./central/nakhon-pathom/nakhon-pathom-thumb.webp": 4919,
	"./central/nonthaburi/nonthaburi-1.webp": 32508,
	"./central/nonthaburi/nonthaburi-2.webp": 3265,
	"./central/nonthaburi/nonthaburi-3.webp": 73561,
	"./central/nonthaburi/nonthaburi-4.webp": 24653,
	"./central/nonthaburi/nonthaburi-5.webp": 27643,
	"./central/nonthaburi/nonthaburi-6.webp": 17336,
	"./central/nonthaburi/nonthaburi-thumb.webp": 70861,
	"./central/pathum-thani/pathum-thani-1.webp": 92621,
	"./central/pathum-thani/pathum-thani-2.webp": 94781,
	"./central/pathum-thani/pathum-thani-3.webp": 41478,
	"./central/pathum-thani/pathum-thani-4.webp": 62063,
	"./central/pathum-thani/pathum-thani-thumb.webp": 14454,
	"./central/phetchaburi/phetchaburi -1.webp": 36205,
	"./central/phetchaburi/phetchaburi -2.webp": 39027,
	"./central/phetchaburi/phetchaburi -3.webp": 71025,
	"./central/phetchaburi/phetchaburi-thumb.webp": 16577,
	"./central/prachuap-khiri-khan/prachuap-khiri-khan-1.webp": 28730,
	"./central/prachuap-khiri-khan/prachuap-khiri-khan-thumb.webp": 79785,
	"./central/ratchaburi/ratchaburi-1.webp": 12786,
	"./central/ratchaburi/ratchaburi-2.webp": 83102,
	"./central/ratchaburi/ratchaburi-3.webp": 35615,
	"./central/ratchaburi/ratchaburi-4.webp": 40121,
	"./central/ratchaburi/ratchaburi-5.webp": 2155,
	"./central/ratchaburi/ratchaburi-thumb.webp": 71236,
	"./central/samut-sakhon/samut-sakhon-1.webp": 98393,
	"./central/samut-sakhon/samut-sakhon-2.webp": 18799,
	"./central/samut-sakhon/samut-sakhon-3.webp": 26802,
	"./central/samut-sakhon/samut-sakhon-4.webp": 57292,
	"./central/samut-sakhon/samut-sakhon-thumb.webp": 69902,
	"./central/samut-songkhram/samut-songkhram-1.webp": 13276,
	"./central/samut-songkhram/samut-songkhram-2.webp": 21309,
	"./central/samut-songkhram/samut-songkhram-3.webp": 51924,
	"./central/samut-songkhram/samut-songkhram-4.webp": 71799,
	"./central/samut-songkhram/samut-songkhram-5.webp": 868,
	"./central/samut-songkhram/samut-songkhram-thumb.webp": 9651,
	"./central/saraburi/saraburi-1.webp": 13181,
	"./central/saraburi/saraburi-2.webp": 50974,
	"./central/saraburi/saraburi-3.webp": 71699,
	"./central/saraburi/saraburi-4.webp": 4800,
	"./central/saraburi/saraburi-5.webp": 73812,
	"./central/saraburi/saraburi-thumb.webp": 23232,
	"./central/sing-buri/sing-buri-1.webp": 19919,
	"./central/sing-buri/sing-buri-2.webp": 83239,
	"./central/sing-buri/sing-buri-3.webp": 97552,
	"./central/sing-buri/sing-buri-4.webp": 4070,
	"./central/sing-buri/sing-buri-5.webp": 94959,
	"./central/sing-buri/sing-buri-6.webp": 77353,
	"./central/sing-buri/sing-buri-thumb.webp": 91387,
	"./central/suphan-buri/suphan-buri-1.webp": 92023,
	"./central/suphan-buri/suphan-buri-2.webp": 18544,
	"./central/suphan-buri/suphan-buri-3.webp": 96071,
	"./central/suphan-buri/suphan-buri-4.webp": 78494,
	"./central/suphan-buri/suphan-buri-5.webp": 52711,
	"./central/suphan-buri/suphan-buri-thumb.webp": 48933,
	"./eastern/chachoengsao/chachoengsao-1.webp": 18410,
	"./eastern/chachoengsao/chachoengsao-2.webp": 56393,
	"./eastern/chachoengsao/chachoengsao-3.webp": 5969,
	"./eastern/chachoengsao/chachoengsao-thumb.webp": 56468,
	"./eastern/chanthaburi/chanthaburi-1.webp": 2476,
	"./eastern/chanthaburi/chanthaburi-2.webp": 13864,
	"./eastern/chanthaburi/chanthaburi-3.webp": 95989,
	"./eastern/chanthaburi/chanthaburi-4.webp": 99942,
	"./eastern/chanthaburi/chanthaburi-5.webp": 72322,
	"./eastern/chanthaburi/chanthaburi-6.webp": 18900,
	"./eastern/chanthaburi/chanthaburi-thumb.webp": 19295,
	"./eastern/chonburi/chonburi-1.webp": 71059,
	"./eastern/chonburi/chonburi-2.webp": 37675,
	"./eastern/chonburi/chonburi-3.webp": 48266,
	"./eastern/chonburi/chonburi-thumb.webp": 65979,
	"./eastern/nakhonnayok/nakhonnayok-1.webp": 39021,
	"./eastern/nakhonnayok/nakhonnayok-2.webp": 43733,
	"./eastern/nakhonnayok/nakhonnayok-3.webp": 36800,
	"./eastern/nakhonnayok/nakhonnayok-4.webp": 89740,
	"./eastern/nakhonnayok/nakhonnayok-5.webp": 97463,
	"./eastern/nakhonnayok/nakhonnayok-thumb.webp": 92470,
	"./eastern/prachinburi/prachinburi-1.webp": 71946,
	"./eastern/prachinburi/prachinburi-2.webp": 38386,
	"./eastern/prachinburi/prachinburi-3.webp": 45015,
	"./eastern/prachinburi/prachinburi-4.webp": 85742,
	"./eastern/prachinburi/prachinburi-5.webp": 98727,
	"./eastern/prachinburi/prachinburi-6.webp": 31565,
	"./eastern/prachinburi/prachinburi-thumb.webp": 96131,
	"./eastern/rayong/rayong-1.webp": 25194,
	"./eastern/rayong/rayong-2.webp": 57812,
	"./eastern/rayong/rayong-3.webp": 64553,
	"./eastern/rayong/rayong-thumb.webp": 34245,
	"./eastern/sakaeo/sakaeo-1.webp": 67887,
	"./eastern/sakaeo/sakaeo-2.webp": 76717,
	"./eastern/sakaeo/sakaeo-3.webp": 32814,
	"./eastern/sakaeo/sakaeo-4.webp": 38949,
	"./eastern/sakaeo/sakaeo-5.webp": 79946,
	"./eastern/sakaeo/sakaeo-thumb.webp": 23794,
	"./eastern/samutprakan/samutprakan-1.webp": 50289,
	"./eastern/samutprakan/samutprakan-2.webp": 88323,
	"./eastern/samutprakan/samutprakan-3.webp": 70084,
	"./eastern/samutprakan/samutprakan-4.webp": 47209,
	"./eastern/samutprakan/samutprakan-thumb.webp": 82721,
	"./eastern/trat/trat-1.webp": 52223,
	"./eastern/trat/trat-2.webp": 95047,
	"./eastern/trat/trat-3.webp": 36514,
	"./eastern/trat/trat-4.webp": 79178,
	"./eastern/trat/trat-5.webp": 99112,
	"./eastern/trat/trat-6.webp": 69780,
	"./eastern/trat/trat-thumb.webp": 81944,
	"./north/chiangmai/chiangmai-1.webp": 77713,
	"./north/chiangmai/chiangmai-2.webp": 96449,
	"./north/chiangmai/chiangmai-3.webp": 88301,
	"./north/chiangmai/chiangmai-4.webp": 18581,
	"./north/chiangmai/chiangmai-5.webp": 11904,
	"./north/chiangmai/chiangmai-6.webp": 6290,
	"./north/chiangmai/chiangmai-thumb.webp": 94054,
	"./north/chiangrai/chiangrai-1.webp": 25852,
	"./north/chiangrai/chiangrai-2.webp": 87415,
	"./north/chiangrai/chiangrai-3.webp": 21126,
	"./north/chiangrai/chiangrai-4.webp": 80960,
	"./north/chiangrai/chiangrai-5.webp": 71047,
	"./north/chiangrai/chiangrai-6.webp": 48911,
	"./north/chiangrai/chiangrai-thumb.webp": 57910,
	"./north/kamphaeng-phet/kamphaeng-phet-1.webp": 62843,
	"./north/kamphaeng-phet/kamphaeng-phet-2.webp": 77918,
	"./north/kamphaeng-phet/kamphaeng-phet-3.webp": 30542,
	"./north/kamphaeng-phet/kamphaeng-phet-4.webp": 82437,
	"./north/kamphaeng-phet/kamphaeng-phet-5.webp": 12089,
	"./north/kamphaeng-phet/kamphaeng-phet-6.webp": 92488,
	"./north/kamphaeng-phet/kamphaeng-phet-thumb.webp": 44412,
	"./north/lampang/lampang-1.webp": 89562,
	"./north/lampang/lampang-2.webp": 67048,
	"./north/lampang/lampang-3.webp": 81295,
	"./north/lampang/lampang-4.webp": 39617,
	"./north/lampang/lampang-5.webp": 28053,
	"./north/lampang/lampang-thumb.webp": 17856,
	"./north/lamphun/lamphun-1.webp": 42614,
	"./north/lamphun/lamphun-2.webp": 24284,
	"./north/lamphun/lamphun-3.webp": 62990,
	"./north/lamphun/lamphun-4.webp": 16427,
	"./north/lamphun/lamphun-thumb.webp": 15598,
	"./north/mae-hong-son/mae-hong-son-1.webp": 51359,
	"./north/mae-hong-son/mae-hong-son-2.webp": 87745,
	"./north/mae-hong-son/mae-hong-son-3.webp": 59624,
	"./north/mae-hong-son/mae-hong-son-4.webp": 72904,
	"./north/mae-hong-son/mae-hong-son-5.webp": 37424,
	"./north/mae-hong-son/mae-hong-son-6.webp": 73255,
	"./north/mae-hong-son/mae-hong-son-thumb.webp": 69689,
	"./north/nakhon-sawan/nakhon-sawan-1.webp": 48206,
	"./north/nakhon-sawan/nakhon-sawan-2.webp": 19980,
	"./north/nakhon-sawan/nakhon-sawan-3.webp": 1069,
	"./north/nakhon-sawan/nakhon-sawan-4.webp": 60096,
	"./north/nakhon-sawan/nakhon-sawan-5.webp": 30190,
	"./north/nakhon-sawan/nakhon-sawan-thumb.webp": 36000,
	"./north/nan/nan-1.webp": 22843,
	"./north/nan/nan-2.webp": 8774,
	"./north/nan/nan-3.webp": 33845,
	"./north/nan/nan-4.webp": 32619,
	"./north/nan/nan-thumb.webp": 62186,
	"./north/phayao/phayao-1.webp": 85683,
	"./north/phayao/phayao-2.webp": 99090,
	"./north/phayao/phayao-3.webp": 70089,
	"./north/phayao/phayao-4.webp": 87048,
	"./north/phayao/phayao-5.webp": 57616,
	"./north/phayao/phayao-6.webp": 43554,
	"./north/phayao/phayao-thumb.webp": 462,
	"./north/phetchabun/phetchabun-1.webp": 47132,
	"./north/phetchabun/phetchabun-2.webp": 31738,
	"./north/phetchabun/phetchabun-3.webp": 45363,
	"./north/phetchabun/phetchabun-4.webp": 57424,
	"./north/phetchabun/phetchabun-5.webp": 4723,
	"./north/phetchabun/phetchabun-thumb.webp": 14749,
	"./north/phichit/phichit-1.webp": 66582,
	"./north/phichit/phichit-2.webp": 96605,
	"./north/phichit/phichit-3.webp": 94681,
	"./north/phichit/phichit-4.webp": 66781,
	"./north/phichit/phichit-5.webp": 10269,
	"./north/phichit/phichit-6.webp": 22542,
	"./north/phichit/phichit-thumb.webp": 91461,
	"./north/phitsanulok/phitsanulok-1.webp": 45855,
	"./north/phitsanulok/phitsanulok-2.webp": 10366,
	"./north/phitsanulok/phitsanulok-3.webp": 38671,
	"./north/phitsanulok/phitsanulok-4.webp": 51688,
	"./north/phitsanulok/phitsanulok-thumb.webp": 6473,
	"./north/phrae/phrae-1.webp": 97664,
	"./north/phrae/phrae-2.webp": 34518,
	"./north/phrae/phrae-3.webp": 7761,
	"./north/phrae/phrae-4.webp": 4820,
	"./north/phrae/phrae-5.webp": 41133,
	"./north/phrae/phrae-6.webp": 5989,
	"./north/phrae/phrae-thumb.webp": 42325,
	"./north/sukhothai/sukhothai-1.webp": 57590,
	"./north/sukhothai/sukhothai-2.webp": 55506,
	"./north/sukhothai/sukhothai-3.webp": 92911,
	"./north/sukhothai/sukhothai-4.webp": 16870,
	"./north/sukhothai/sukhothai-5.webp": 63911,
	"./north/sukhothai/sukhothai-6.webp": 59048,
	"./north/sukhothai/sukhothai-thumb.webp": 50026,
	"./north/tak/tak-1.webp": 72529,
	"./north/tak/tak-2.webp": 63802,
	"./north/tak/tak-3.webp": 97518,
	"./north/tak/tak-4.webp": 35152,
	"./north/tak/tak-5.webp": 90191,
	"./north/tak/tak-6.webp": 48425,
	"./north/tak/tak-thumb.webp": 40817,
	"./north/uthai-thani/uthai-thani-1.webp": 9296,
	"./north/uthai-thani/uthai-thani-2.webp": 22399,
	"./north/uthai-thani/uthai-thani-3.webp": 25365,
	"./north/uthai-thani/uthai-thani-4.webp": 43452,
	"./north/uthai-thani/uthai-thani-5.webp": 12960,
	"./north/uthai-thani/uthai-thani-6.webp": 68325,
	"./north/uthai-thani/uthai-thani-thumb.webp": 62038,
	"./north/uttaradit/uttaradit-1.webp": 15136,
	"./north/uttaradit/uttaradit-2.webp": 12791,
	"./north/uttaradit/uttaradit-3.webp": 15336,
	"./north/uttaradit/uttaradit-4.webp": 66943,
	"./north/uttaradit/uttaradit-5.webp": 35860,
	"./north/uttaradit/uttaradit-thumb.webp": 57493,
	"./northeast/amnat-charoen/amnat-charoen-1.webp": 77031,
	"./northeast/amnat-charoen/amnat-charoen-2.webp": 5957,
	"./northeast/amnat-charoen/amnat-charoen-3.webp": 12677,
	"./northeast/amnat-charoen/amnat-charoen-4.webp": 16374,
	"./northeast/amnat-charoen/amnat-charoen-5.webp": 14036,
	"./northeast/amnat-charoen/amnat-charoen-thumb.webp": 44875,
	"./northeast/bueng-kan/bueng-kan-1.webp": 8813,
	"./northeast/bueng-kan/bueng-kan-2.webp": 62469,
	"./northeast/bueng-kan/bueng-kan-3.webp": 72610,
	"./northeast/bueng-kan/bueng-kan-4.webp": 59769,
	"./northeast/bueng-kan/bueng-kan-5.webp": 16146,
	"./northeast/bueng-kan/bueng-kan-thumb.webp": 15917,
	"./northeast/buriram/buriram-1.webp": 89484,
	"./northeast/buriram/buriram-2.webp": 74020,
	"./northeast/buriram/buriram-3.webp": 82003,
	"./northeast/buriram/buriram-4.webp": 5523,
	"./northeast/buriram/buriram-5.webp": 96206,
	"./northeast/buriram/buriram-6.webp": 21060,
	"./northeast/buriram/buriram-thumb.webp": 46596,
	"./northeast/chaiyaphum/chaiyaphum-1.webp": 87769,
	"./northeast/chaiyaphum/chaiyaphum-2.webp": 79176,
	"./northeast/chaiyaphum/chaiyaphum-3.webp": 94649,
	"./northeast/chaiyaphum/chaiyaphum-4.webp": 71335,
	"./northeast/chaiyaphum/chaiyaphum-5.webp": 8331,
	"./northeast/chaiyaphum/chaiyaphum-thumb.webp": 44290,
	"./northeast/kalasin/kalasin-1.webp": 31718,
	"./northeast/kalasin/kalasin-2.webp": 79293,
	"./northeast/kalasin/kalasin-3.webp": 74904,
	"./northeast/kalasin/kalasin-4.webp": 53626,
	"./northeast/kalasin/kalasin-5.webp": 63866,
	"./northeast/kalasin/kalasin-6.webp": 74700,
	"./northeast/kalasin/kalasin-thumb.webp": 28278,
	"./northeast/khonkaen/khonkaen-1.webp": 80951,
	"./northeast/khonkaen/khonkaen-2.webp": 59280,
	"./northeast/khonkaen/khonkaen-3.webp": 91523,
	"./northeast/khonkaen/khonkaen-4.webp": 99451,
	"./northeast/khonkaen/khonkaen-5.webp": 9088,
	"./northeast/khonkaen/khonkaen-thumb.webp": 16869,
	"./northeast/loei/loei-1.webp": 86528,
	"./northeast/loei/loei-2.webp": 17666,
	"./northeast/loei/loei-3.webp": 14590,
	"./northeast/loei/loei-thumb.webp": 13966,
	"./northeast/maha-sarakham/maha-sarakham-1.webp": 90915,
	"./northeast/maha-sarakham/maha-sarakham-2.webp": 63030,
	"./northeast/maha-sarakham/maha-sarakham-3.webp": 85930,
	"./northeast/maha-sarakham/maha-sarakham-4.webp": 16367,
	"./northeast/maha-sarakham/maha-sarakham-5.webp": 28527,
	"./northeast/maha-sarakham/maha-sarakham-thumb.webp": 13953,
	"./northeast/mukdahan/mukdahan-1.webp": 89765,
	"./northeast/mukdahan/mukdahan-2.webp": 24056,
	"./northeast/mukdahan/mukdahan-3.webp": 8871,
	"./northeast/mukdahan/mukdahan-4.webp": 67847,
	"./northeast/mukdahan/mukdahan-5.webp": 59056,
	"./northeast/mukdahan/mukdahan-6.webp": 24191,
	"./northeast/mukdahan/mukdahan-thumb.webp": 1971,
	"./northeast/nakhon-phanom/nakhon-phanom-1.webp": 42608,
	"./northeast/nakhon-phanom/nakhon-phanom-2.webp": 5756,
	"./northeast/nakhon-phanom/nakhon-phanom-3.webp": 33095,
	"./northeast/nakhon-phanom/nakhon-phanom-4.webp": 72384,
	"./northeast/nakhon-phanom/nakhon-phanom-5.webp": 46452,
	"./northeast/nakhon-phanom/nakhon-phanom-6.webp": 68182,
	"./northeast/nakhon-phanom/nakhon-phanom-thumb.webp": 96572,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-1.webp": 43543,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-2.webp": 58041,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-3.webp": 77783,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-4.webp": 47264,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-5.webp": 6908,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-thumb.webp": 94333,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-1.webp": 68680,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-2.webp": 81610,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-3.webp": 80369,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-4.webp": 96610,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-5.webp": 80239,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-6.webp": 13794,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-thumb.webp": 34174,
	"./northeast/nong-khai/nong-khai-1.webp": 18652,
	"./northeast/nong-khai/nong-khai-2.webp": 16236,
	"./northeast/nong-khai/nong-khai-3.webp": 25779,
	"./northeast/nong-khai/nong-khai-4.webp": 57878,
	"./northeast/nong-khai/nong-khai-5.webp": 18267,
	"./northeast/nong-khai/nong-khai-thumb.webp": 26225,
	"./northeast/roiet/roiet-1.webp": 92859,
	"./northeast/roiet/roiet-2.webp": 25099,
	"./northeast/roiet/roiet-3.webp": 57789,
	"./northeast/roiet/roiet-4.webp": 33292,
	"./northeast/roiet/roiet-5.webp": 7531,
	"./northeast/roiet/roiet-6.webp": 71461,
	"./northeast/roiet/roiet-thumb.webp": 81155,
	"./northeast/sakon-nakhon/sakon-nakhon-1.webp": 95342,
	"./northeast/sakon-nakhon/sakon-nakhon-2.webp": 39007,
	"./northeast/sakon-nakhon/sakon-nakhon-3.webp": 77147,
	"./northeast/sakon-nakhon/sakon-nakhon-4.webp": 16066,
	"./northeast/sakon-nakhon/sakon-nakhon-5.webp": 11645,
	"./northeast/sakon-nakhon/sakon-nakhon-6.webp": 23211,
	"./northeast/sakon-nakhon/sakon-nakhon-thumb.webp": 1430,
	"./northeast/sisaket/sisaket-1.webp": 30330,
	"./northeast/sisaket/sisaket-2.webp": 2218,
	"./northeast/sisaket/sisaket-3.webp": 24440,
	"./northeast/sisaket/sisaket-thumb.webp": 3580,
	"./northeast/surin/surin-1.webp": 48352,
	"./northeast/surin/surin-2.webp": 61504,
	"./northeast/surin/surin-3.webp": 46451,
	"./northeast/surin/surin-4.webp": 62949,
	"./northeast/surin/surin-thumb.webp": 87444,
	"./northeast/ubon-ratchathani/ubon-ratchathani-1.webp": 48405,
	"./northeast/ubon-ratchathani/ubon-ratchathani-2.webp": 90143,
	"./northeast/ubon-ratchathani/ubon-ratchathani-3.webp": 72337,
	"./northeast/ubon-ratchathani/ubon-ratchathani-4.webp": 73313,
	"./northeast/ubon-ratchathani/ubon-ratchathani-5.webp": 17801,
	"./northeast/ubon-ratchathani/ubon-ratchathani-6.webp": 43320,
	"./northeast/ubon-ratchathani/ubon-ratchathani-thumb.webp": 72382,
	"./northeast/udon-thani/udon-thani-1.webp": 29025,
	"./northeast/udon-thani/udon-thani-2.webp": 57330,
	"./northeast/udon-thani/udon-thani-3.webp": 84873,
	"./northeast/udon-thani/udon-thani-4.webp": 79637,
	"./northeast/udon-thani/udon-thani-5.webp": 61185,
	"./northeast/udon-thani/udon-thani-6.webp": 2691,
	"./northeast/udon-thani/udon-thani-thumb.webp": 63724,
	"./northeast/yasothon/yasothon-1.webp": 6223,
	"./northeast/yasothon/yasothon-2.webp": 71225,
	"./northeast/yasothon/yasothon-3.webp": 98575,
	"./northeast/yasothon/yasothon-4.webp": 18662,
	"./northeast/yasothon/yasothon-5.webp": 88097,
	"./northeast/yasothon/yasothon-6.webp": 23419,
	"./northeast/yasothon/yasothon-thumb.webp": 4143,
	"./south/chumphon/chumphon-1.webp": 32154,
	"./south/chumphon/chumphon-2.webp": 61765,
	"./south/chumphon/chumphon-3.webp": 20284,
	"./south/chumphon/chumphon-4.webp": 21855,
	"./south/chumphon/chumphon-5.webp": 40900,
	"./south/chumphon/chumphon-6.webp": 73477,
	"./south/chumphon/chumphon-thumb.webp": 72203,
	"./south/krabi/krabi-1.webp": 7990,
	"./south/krabi/krabi-2.webp": 32390,
	"./south/krabi/krabi-3.webp": 5220,
	"./south/krabi/krabi-thumb.webp": 11718,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-1.webp": 76020,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-2.webp": 63580,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-3.webp": 96648,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-4.webp": 58896,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-5.webp": 46608,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-thumb.webp": 8572,
	"./south/narathiwat/narathiwat-1.webp": 88849,
	"./south/narathiwat/narathiwat-2.webp": 63475,
	"./south/narathiwat/narathiwat-3.webp": 96749,
	"./south/narathiwat/narathiwat-4.webp": 37478,
	"./south/narathiwat/narathiwat-5.webp": 91617,
	"./south/narathiwat/narathiwat-6.webp": 886,
	"./south/narathiwat/narathiwat-thumb.webp": 91946,
	"./south/pattani/pattani-1.webp": 32709,
	"./south/pattani/pattani-2.webp": 25681,
	"./south/pattani/pattani-3.webp": 52596,
	"./south/pattani/pattani-4.webp": 78601,
	"./south/pattani/pattani-5.webp": 97077,
	"./south/pattani/pattani-thumb.webp": 50331,
	"./south/phangnga/phangnga-1.webp": 56737,
	"./south/phangnga/phangnga-2.webp": 54379,
	"./south/phangnga/phangnga-3.webp": 82679,
	"./south/phangnga/phangnga-4.webp": 45946,
	"./south/phangnga/phangnga-5.webp": 52153,
	"./south/phangnga/phangnga-6.webp": 40382,
	"./south/phangnga/phangnga-thumb.webp": 76761,
	"./south/phatthalung/phatthalung-1.webp": 63399,
	"./south/phatthalung/phatthalung-2.webp": 17862,
	"./south/phatthalung/phatthalung-3.webp": 591,
	"./south/phatthalung/phatthalung-4.webp": 36164,
	"./south/phatthalung/phatthalung-thumb.webp": 55423,
	"./south/phuket/phuket-1.webp": 70606,
	"./south/phuket/phuket-2.webp": 36893,
	"./south/phuket/phuket-3.webp": 38930,
	"./south/phuket/phuket-4.webp": 16352,
	"./south/phuket/phuket-5.webp": 68723,
	"./south/phuket/phuket-thumb.webp": 81705,
	"./south/ranong/ranong-1.webp": 14057,
	"./south/ranong/ranong-2.webp": 97044,
	"./south/ranong/ranong-3.webp": 1238,
	"./south/ranong/ranong-4.webp": 70572,
	"./south/ranong/ranong-5.webp": 11829,
	"./south/ranong/ranong-thumb.webp": 29664,
	"./south/satun/satun-1.webp": 39790,
	"./south/satun/satun-2.webp": 98752,
	"./south/satun/satun-3.webp": 95318,
	"./south/satun/satun-4.webp": 71769,
	"./south/satun/satun-thumb.webp": 12856,
	"./south/songkhla/songkhla-1.webp": 28950,
	"./south/songkhla/songkhla-2.webp": 44143,
	"./south/songkhla/songkhla-3.webp": 96254,
	"./south/songkhla/songkhla-4.webp": 1882,
	"./south/songkhla/songkhla-5.webp": 44516,
	"./south/songkhla/songkhla-6.webp": 23250,
	"./south/songkhla/songkhla-thumb.webp": 86168,
	"./south/surat-thani/surat-thani-1.webp": 69263,
	"./south/surat-thani/surat-thani-2.webp": 38952,
	"./south/surat-thani/surat-thani-3.webp": 93807,
	"./south/surat-thani/surat-thani-4.webp": 32028,
	"./south/surat-thani/surat-thani-thumb.webp": 46398,
	"./south/trang/trang-1.webp": 44041,
	"./south/trang/trang-2.webp": 88271,
	"./south/trang/trang-3.webp": 99288,
	"./south/trang/trang-4.webp": 52973,
	"./south/trang/trang-5.webp": 15553,
	"./south/trang/trang-6.webp": 97875,
	"./south/trang/trang-thumb.webp": 48155,
	"./south/yala/yala-1.webp": 37378,
	"./south/yala/yala-2.webp": 54104,
	"./south/yala/yala-3.webp": 39416,
	"./south/yala/yala-4.webp": 3711,
	"./south/yala/yala-5.webp": 57471,
	"./south/yala/yala-6.webp": 87994,
	"./south/yala/yala-thumb.webp": 12379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86054;